import { Sponsor } from '@/models/sponsor';
import { Session } from '@/models/session';
import { PropType } from 'vue';
import { validateSponsor } from './utils';

export interface Category {
  [prop: string]: any;
}
export const base = {
  loading: {
    type: Boolean,
    default: false
  }
};
export const detail = {
  options: {
    type: Object as PropType<any>
  },
  sponsor: {
    type: Object as PropType<Sponsor>,
    required: true,
    validate: validateSponsor
  },
  categories: {
    type: Array as PropType<Category>,
    default: () => []
  }
};
export const functions = {
  save: {
    type: Function,
    required: false,
    validate: () => ({})
  }
};
export default { base, detail, functions };
